/* istanbul ignore file */
import React from 'react';
import { Badge } from 'framework/ui/mui-builder';
import { FieldBadgeProps } from 'framework/ui/ui-builder';

const ContractorBadge = (props: FieldBadgeProps) => {
  return (
    <Badge color="primary" sx={{ ml: 1 }} {...props}>
      Contractor
    </Badge>
  );
};

export default ContractorBadge;
